import { useEffect } from 'react';
import { ThemeProvider as BaseThemeProvider } from 'styled-components';

import { GlobalStyles } from './GlobalStyles.js';
import { CustomThemeConfig } from './GlobalStylesTypes.js';
import { generateCustomPaletteCSS } from './GlobalStylesUtils.js';

export interface Theme {}

declare module 'styled-components' {
  export interface DefaultTheme extends Theme {}
}

export interface ThemeProviderProps {
  children: React.ReactNode;
  customTheme?: CustomThemeConfig;
}

const CUSTOM_THEME_STYLE_ID = 'spz-custom-theme';

const CustomThemeStyles: React.FC<{ theme: CustomThemeConfig }> = ({ theme }) => {
  useEffect(() => {
    const css = generateCustomPaletteCSS(theme);
    let el = document.getElementById(CUSTOM_THEME_STYLE_ID) as HTMLStyleElement | null;
    if (!el) {
      el = document.createElement('style');
      el.id = CUSTOM_THEME_STYLE_ID;
      document.head.appendChild(el);
    }
    el.textContent = css;

    return () => {
      el?.remove();
    };
  }, [theme]);

  return null;
};

// TODO remove the default theme until we port the DataTable and Dialog components in uikit
export const ThemeProvider: React.FC<ThemeProviderProps> = ({ children, customTheme }) => {
  return (
    <BaseThemeProvider theme={{}}>
      <GlobalStyles />
      {customTheme && Object.keys(customTheme).length > 0 && (
        <CustomThemeStyles theme={customTheme} />
      )}
      {children}
    </BaseThemeProvider>
  );
};
